/* eslint-disable @typescript-eslint/no-explicit-any */
import { Radio } from 'antd';
import React, { memo } from 'react';

interface IOptions {
    value: number | string | boolean;
    id: number | string;
}

interface IProps {
    className?: string;
    options?: IOptions[];
    field?: any;
    defaultValue?: any;
}

const RadioWrap: React.FC<IProps> = ({ className, options, field, defaultValue }) => {
    return (
        <Radio.Group className={`${className}`} {...field} defaultValue={defaultValue}>
            {options?.map((item: IOptions) => (
                <Radio key={item.id} value={item.id}>
                    {item.value}
                </Radio>
            ))}
        </Radio.Group>
    );
};

export default memo(RadioWrap);
